<template>
  <div class="body">
    <div class="contents">
      <div class="fqa-left">
        <p class="fqa-left-title">
          帮助中心
        </p>
        <ul>
          <li :class="{ active: sindex == 5 }" @click="checkitem(5)">
            功能介绍
          </li>
          <li :class="{ active: sindex == 1 }" @click="checkitem(1)">
            账户设置
          </li>
          <li :class="{ active: sindex == 2 }" @click="checkitem(2)">
            在线采购
          </li>
          <li :class="{ active: sindex == 3 }" @click="checkitem(3)">
            产品服务
          </li>
          <li :class="{ active: sindex == 4 }" @click="checkitem(4)">
            供应商合作
          </li>
        </ul>
      </div>
      <div class="fqa-right">
        <div v-if="sindex == 1" class="fqa-right-item">
          <p class="fqa-right-title">账户设置</p>
          <p class="fqa-right-title-two">忘记密码</p>
          <p class="fqa-right-info">1、登录页点击忘记密码</p>
          <div class="demo-image__lazy">
            <el-image src="/static/help/zhanghu/1.5/1.jpg" lazy></el-image>
          </div>

          <p class="fqa-right-info">
            2、输入您注册时填写的电子邮件。我们将向您发送一封电子邮件。
          </p>
          <div class="demo-image__lazy">
            <el-image src="/static/help/zhanghu/1.5/2.jpg" lazy></el-image>
          </div>

          <p class="fqa-right-info">
            3、登录邮箱，找到邮件，点击邮件内的链接重置密码。
          </p>
          <div class="demo-image__lazy">
            <el-image src="/static/help/zhanghu/1.5/3.jpg" lazy></el-image>
          </div>

          <p class="fqa-right-title-two">如何修改个人信息？</p>
          <p class="fqa-right-info">1、登录后点击【用户中心】-用户信息-修改</p>
          <div class="demo-image__lazy">
            <el-image src="/static/help/zhanghu/1.5/4.jpg" lazy></el-image>
          </div>

          <p class="fqa-right-title-two">如何管理已收藏的商品？</p>
          <div class="demo-image__lazy">
            <el-image src="/static/help/zhanghu/1.5/5.jpg" lazy></el-image>
          </div>
        </div>

        <div v-if="sindex == 2" class="fqa-right-item">
          <p class="fqa-right-title">在线采购</p>
          <p class="fqa-right-title-two">如何获取商品报价</p>
          <p class="fqa-right-info">
            1、如需购买或咨询该商品，在商品详情页点击【联系我们】填写表单，描述您想要咨询的问题，并留下您的联系方式，我们的销售人员会通过电话、邮件的方式联系您。
          </p>
          <div class="demo-image__lazy">
            <el-image src="/static/help/caigou/1.5/1.jpg" lazy></el-image>
          </div>
          <div class="demo-image__lazy">
            <el-image src="/static/help/caigou/1.5/2.jpg" lazy></el-image>
          </div>

          <p class="fqa-right-title-two">如何获取行业解决方案</p>
          <p class="fqa-right-info">
            1、如需获取相关解决方案，填写网站内任意表单，描述您想要咨询的问题，并留下您的联系方式，我们的销售人员会通过电话、邮件的方式联系您。
          </p>
          <div class="demo-image__lazy">
            <el-image src="/static/help/caigou/1.5/3.jpg" lazy></el-image>
          </div>
        </div>

        <div v-if="sindex == 3" class="fqa-right-item">
          <p class="fqa-right-title">产品服务</p>
          <p class="fqa-right-title-two">如何使用商品筛选功能</p>
          <p class="fqa-right-info">1、点击产品分类。</p>
          <div class="demo-image__lazy">
            <el-image src="/static/help/service/1.5/1.jpg" lazy></el-image>
          </div>
          <p class="fqa-right-info">
            2、根据条件筛选，缩小筛选范围，更容易找到目标商品。
          </p>

          <div class="demo-image__lazy">
            <el-image src="/static/help/service/1.5/2.jpg" lazy></el-image>
          </div>

          <p class="fqa-right-title-two">如何获取更多商品信息</p>
          <p class="fqa-right-info">
            1、找到意向商品后，点击商品，进入产品详情页，可浏览商品信息，下载产品手册。
          </p>
          <div class="demo-image__lazy">
            <el-image src="/static/help/service/1.5/3.jpg" lazy></el-image>
          </div>
          <div class="demo-image__lazy">
            <el-image src="/static/help/service/1.5/4.jpg" lazy></el-image>
          </div>
        </div>

        <div v-if="sindex == 4" class="fqa-right-item">
          <p class="fqa-right-title">供应商合作</p>
          <p class="fqa-right-title-two">如何联系我们与我们合作</p>
          <p class="fqa-right-info">
            1、点击支持—供应商合作，可填写页面内的表单等待我们联系您，或通过网站预留的电话、邮箱与我们联系。
          </p>
          <div class="demo-image__lazy">
            <el-image src="/static/help/suppllier/1.5/1.jpg" lazy></el-image>
          </div>
          <p class="fqa-right-info">2、点击支持—供应商合作</p>

          <div class="demo-image__lazy">
            <el-image src="/static/help/suppllier/1.5/2.jpg" lazy></el-image>
          </div>
        </div>
        <div v-if="sindex == 5" class="fqa-right-item">
          <p class="fqa-right-title">功能介绍</p>
          <p class="fqa-right-info">
            1、登录/注册
          </p>
          <p class="fqa-right-tips">
            • 网站与移动端/小程序应用支持：手机短信验证码登录，账号密码登录。
          </p>
          <p class="fqa-right-info">
            2、搜索
          </p>
          <p class="fqa-right-tips">
            •
            用户可在首页搜索框输入所想要查找的商品名称、商品型号或品牌，可轻松找到想要搜索的内容。或依据导航按分类筛选找到需要的商品。
          </p>
          <p class="fqa-right-info">
            3、产品类别
          </p>
          <p class="fqa-right-tips">
            •
            本站汇集中国工业机器人上下游产业链优质产品，包括有减速机、电机、驱动器、工业机器人本体、机器人控制系统、机器人视觉系统等，每个产品都配有详细的介绍，产品参数齐全、同时还提供配套三维模型和产品手册下载。
          </p>
          <p class="fqa-right-tips">
            •
            用户可按照产品类别和需求筛选产品，如需购买可点击产品详情页面上【我要采购】按钮，填写表单联系我们。
          </p>
          <p class="fqa-right-info">
            4、品牌
          </p>
          <p class="fqa-right-tips">
            •
            每个品牌都有独立的展示页面，该页面包含【品牌】和【产品】两个部分，【品牌】部分介绍品牌概况和产品技术优势，【产品】部分展示了对应品牌的产品，利于品牌推广，也便于用户更好的了解品牌及产品服务。
          </p>
          <p class="fqa-right-info">
            5、服务行业
          </p>
          <p class="fqa-right-tips">
            •
            提供了11个行业的真实应用案例，包括工业机器人零部件、消费品、商业智能服务、仓储物流、食品、医药、汽车及零部件、机械设备、电子、新能源等，每个案例都能找到对应的品牌或产品，如有需要可填写页面下方的【联系我们】表单，定制产品服务。
          </p>
          <p class="fqa-right-info">
            6、我的收藏
          </p>
          <p class="fqa-right-tips">
            •
            登录后，点击产品页上的“星型”图标，可收藏产品，收藏后的产品可在【用户中心-我的收藏】查看。
          </p>
          <p class="fqa-right-info">
            7、用户中心
          </p>
          <p class="fqa-right-tips">
            •
            登录后，可点击【用户中心】，进行管理账号信息、管理收藏夹、修改密码、退出登录和注销账号等操作。
          </p>
          <p class="fqa-right-info">
            8、注销账号
          </p>
          <p class="fqa-right-tips">
            •
            如需注销账号，点击【用户中心-注销账号】按照页面提示填写信息即可，注销后所有用户数据和信息都将清空，请谨慎操作。
          </p>
          <p class="fqa-right-info">
            9、在线客服
          </p>
          <p class="fqa-right-tips">
            •
            用户拨打客服电话：400-6537789（按2）或15522415492咨询，也可扫描页尾的客服微信二维码添加客服微信咨询，客服工作时间8:30-17:30
            (周一至周六,法定节假日除外)。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sindex: 1
    };
  },
  metaInfo() {
    return {
      title: "Movibot官网_工业机器人上下游供应链",
      meta: [
        {
          name: "keywords",
          content:
            "工业机器人_工业机器人上下游供应链_工业机器人品牌_工业自动化设备_行业解决方案"
        },
        {
          name: "description",
          content:
            "Movibot汇聚中国工业机器人上下游供应链优质工业机器人品牌,为工业机器人,智能家庭及商业应用,仓储物流,食品行业,医药行业,汽车行业,机械设备制造,电子行业提供工业自动化设备和行业解决方案"
        }
      ]
    };
  },
  methods: {
    checkitem(index) {
      this.sindex = index;
    }
  },
  watch: {
    $route(to, from) {
      //监听URL地址栏参数变化
      this.sindex = this.$route.params.sindex;
    }
  },
  mounted() {
    this.sindex = this.$route.params.sindex || 1;
  }
};
</script>

<style scoped>
.body {
  background-color: #f3f5f7;
}
.fqa-left {
  width: 330px;
  float: left;
  background-color: #fff;
  margin-top: 60px;
}
.fqa-right {
  width: 810px;
  float: right;
  background-color: #fff;
  margin-top: 60px;
  padding-bottom: 60px;
  margin-bottom: 160px;
  min-height: 900px;
}
.fqa-right-item {
  margin-left: 65px;
  margin-right: 65px;
  overflow: hidden;
  margin-top: 20px;
}
.active {
  background-color: #e8e8e8;
}
.contents {
  overflow: hidden;
}
.fqa-left-title {
  font-size: 22px;
  color: #333;
  padding-left: 50px;
  line-height: 2;
  margin-top: 20px;
  font-weight: 600;
}
.fqa-right-title {
  font-size: 22px;
  color: #333;
  line-height: 2;
  font-weight: 600;
}
.fqa-right-title-two {
  font-size: 18px;
  color: #333;
  /* line-height:2; */
  font-weight: 600;
  margin-top: 15px;
  margin-bottom: 5px;
}
.fqa-right-info {
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  margin: 10px 0;
}
.fqa-right-tips {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin: 10px 0;
}
.fqa-left ul {
  overflow: hidden;
}
.fqa-left ul li {
  font-size: 16px;
  color: #666;
  padding-left: 50px;
  line-height: 2.5;
  cursor: pointer;
}
.demo-image__lazy >>> .el-image {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/help/fqa.vue